import type { BffCatalogSubscriptionsResponse } from '@/core/models/bff-catalog';
import type { BffCatalogSubscriptionsQueryParams } from '@/core/queries/bff/catalog/bff-catalog-query-keys';
import { getBffCatalogSubscriptions } from '@/core/services/fetchers';

const fetchBffCatalogSubscriptions = async (
  params: BffCatalogSubscriptionsQueryParams,
): Promise<BffCatalogSubscriptionsResponse> =>
  getBffCatalogSubscriptions({
    countryCode: params.countryCode,
    languageCode: params.languageCode,
  });

export default fetchBffCatalogSubscriptions;
